export const changeLocation = {
    event: "coming_soon_city_screen",
    eventCategory: "Buy_used_cars_B2C_Car_Listing_Page",
    eventAction: "coming_soon_city_screen | change_location"
};
